export var REQUEST_TIMEOUT = 30000;
export var UNAVAILABLE_IMAGE_URL = 'https://assets.thdstatic.com/images/v1/no-img.svg';
export var MORE_DATES_VALUE = '__more_dates__';
